module.exports = __webpack_public_path__ + "static/media/GC_logo.e60be19e.svg";